import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import mime from 'mime-types'

export const imageDataUriToBlob = (dataUri: string, contentType: string): Blob => {
  const byteString = atob(dataUri.split(',')[1])
  const arrayBuffer = new ArrayBuffer(byteString.length)
  const uint8Array = new Uint8Array(arrayBuffer)
  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i)
  }
  return new Blob([arrayBuffer], { type: contentType })
}

export const downloadZip = async (
  images: { imageUri: string; contentType: string }[],
  name = 'images'
) => {
  const zip = new JSZip()
  for (let index = 0; index < images.length; index++) {
    const image = images[index]
    zip.file(
      `${index + 1}.${mime.extension(image.contentType)}`,
      imageDataUriToBlob(image.imageUri, image.contentType),
      {
        base64: true,
      }
    )
  }
  const content = await zip.generateAsync({ type: 'blob' })
  saveAs(content, `${name}.zip`)
}
